import { create } from 'zustand'

interface BillingLockStore {
  /**
   * When the API last refused a write with 402. The banner watches it and
   * re-reads /billing/status, so a workspace that became read-only while the
   * tab was open says so at once instead of at the next poll.
   */
  refusedAt: number | null
  markRefused: () => void
}

export const useBillingLockStore = create<BillingLockStore>((set) => ({
  refusedAt: null,
  markRefused: () => set({ refusedAt: Date.now() }),
}))
